import "./Footer.scss";
import Copyright from "../../UI/Copyright/Copyright";
import SocialsMini from "../../UI/Socials/SocialsMini";
import Credits from "../../UI/Copyright/Credits";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
        <Copyright />
        <Link className="footer__link" to="/privacy-policy">Политика конфиденциальности</Link>
        <SocialsMini />
        <Credits classesName="credits"/>
        </div>
      </div>
    </footer>
  )
}

export default Footer;